export const goToHome = () => {
  window.location.href = "/";
};

export const isNumeric = (value: any): boolean => {
  return !isNaN(value) && !isNaN(parseFloat(value)) && isFinite(value);
};

export const preciseSubtract = (a: number, b: number): number => {
  return parseFloat((a - b).toFixed(2));
};